// PBX host type selector, shared by New + Edit forms.
//
// MIRRORS src/lib/pbxTypes.js in cloud/workers — the pnpm workspace boundary prevents a shared
// import, so keep the two in sync. The Worker validates against its copy, so a type present only
// here is refused at provisioning time with "Unsupported PBX type".
//
// When adding a new type:
//   1. Add an entry below AND to SUPPORTED_PBX_TYPES / PBX_TYPES in cloud/workers/src/lib/pbxTypes.js.
//   2. Check the per-type credential fieldsets in New + Edit — both gate on `pbx_type === 'freepbx'`,
//      so a new type shows no credential fields unless you add them.

export const PBX_TYPES = {
  freepbx: {
    key:   'freepbx',
    label: 'FreePBX',
    hint:  'Sangoma FreePBX distro on Asterisk. The full feature set.',
  },
  // verso-agent, AGENT_ASKS #53, 2026-09-03: pbx-04 runs aria-cloud-pbx v0.2.0 — Rust, Postgres,
  // its own SIP stack, no Asterisk and no FreePBX anywhere. The agent's REST contract is
  // unchanged; what it can answer is narrower, and it says so through /capabilities.
  aria: {
    key:   'aria',
    label: 'Aria',
    hint:  'aria-cloud-pbx — Rust + Postgres, its own SIP stack. A narrower feature set, which '
         + 'the host reports for itself; Verso adapts rather than being told.',
  },
};

export default function PbxTypeSelect({ value, onChange, disabled = false }) {
  const options = Object.values(PBX_TYPES);
  const current = PBX_TYPES[value] || options[0];
  return (
    <div>
      <label className="block text-xs font-medium text-gray-700">PBX type</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || options.length === 1}
        className="mt-1 block w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-50 disabled:text-gray-500"
      >
        {options.map((t) => (
          <option key={t.key} value={t.key}>{t.label}</option>
        ))}
      </select>
      {current?.hint && (
        <p className="mt-1 text-[11px] text-gray-500">{current.hint}</p>
      )}
    </div>
  );
}
